import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const APSOFOH_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/apsofoh/logo.png",
        alt: "Affirmations Psychological Services Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 23,
  state: "OH",
  departmentIds: [114, 126, 120, 118],
};
